import React, { Component } from 'react';
import { Grid, Button, Typography, Divider, CircularProgress } from '@material-ui/core';
import ProductsListQuote from '../../ProductsSearch/components/ProductList/ProductsListQuote';
import { withRouter, RouteComponentProps } from 'react-router'
import { Delivery, MissingProduct } from '../../api/models/QuotedData';
import { SimpleMessageQmoModal } from '../../Layout/components/QmoModal';
import { LocalDeliveryTime } from '../../Common/LocalDeliveryTime';
import InfoPopover from '../../Common/InfoPopover';
import { OrderSheetData } from '../../api/models/OrderSheetData';
import { LocationAddress } from '../../api/models/LocationAddress';
import QmoLoader from '../../Common/QmoLoader';

type Props = {
    orderSheet: OrderSheetData,
    quotedOrder: Delivery,
    goNext: () => void,
    isBusy: boolean,
    getDeliveryAddressBusy: boolean,
    getDeliveryAddress: () => void,
    deliveryAddress: LocationAddress,
    noneFulfillsOrder: boolean | null,
    noneFulfillsDeadline: boolean | null,
    missingProducts: MissingProduct[] | null
} & RouteComponentProps<any>

type State = {
    redirectToOrdersheetsOpen: boolean,
    missingProductsCautionOpen: boolean
}

class Quote extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            redirectToOrdersheetsOpen: false,
            missingProductsCautionOpen: false
        }
    }

    componentDidMount() {
        if (this.props.isBusy === false && this.props.quotedOrder === null)
            this.setState({ redirectToOrdersheetsOpen: true })

        if (this.props.getDeliveryAddressBusy === false && this.props.deliveryAddress === null) {
            this.props.getDeliveryAddress()
        }
    }

    renderBadOutcome = (text: string) => {
        return (
            <div style={{ textAlign: 'center' }}>
                <Typography style={{ marginBottom: '25px' }} variant={"h3"}>{text}</Typography>
                <Button variant="outlined" color="primary" onClick={() => this.props.history.push('/Search')} style={{ maxWidth: '300px', width: '100%' }}>Edit order sheet</Button>
            </div>
        )

    }

    renderOutcome = () => {
        if (this.props.noneFulfillsDeadline === true) {
            return (
                this.renderBadOutcome("No supplier is able to deliver your order on selected time. Please reassign the delivery time.")
            )
        }
        else
            if (this.props.noneFulfillsOrder === true) {
                return (
                    this.renderBadOutcome("None of the suppliers is able to deliver all products from your order sheet. Please reassign the items.")
                )
            }
            else {
                return (
                    <Grid container>

                        <Grid item xs={12} sm={12}>
                            <Typography variant="h3">{this.props.orderSheet.name} order products</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <div style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                                <ProductsListQuote quotedOrder={this.props.quotedOrder} missingProducts={this.props.missingProducts} ></ProductsListQuote>
                            </div>
                            <Divider />
                        </Grid>
                        <Grid item xs={12} sm={12} style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                            <Grid container>
                                <Grid item xs={12} sm={4} style={{ textAlign: 'left' }}>
                                    <Typography variant="subtitle1">DELIVERY ADDRESS</Typography>
                                    {this.props.getDeliveryAddressBusy ?
                                        <CircularProgress size={20} />
                                        :
                                        <span>
                                            {this.props.deliveryAddress !== null &&
                                                <span>
                                                    <Typography variant="body2">{this.props.deliveryAddress.streetNumber}&nbsp;{this.props.deliveryAddress.street}</Typography>
                                                    <Typography variant="body2">{this.props.deliveryAddress.suburb},&nbsp;{this.props.deliveryAddress.stateCode}</Typography>
                                                    <Typography variant="body2">{this.props.deliveryAddress.postalCode}</Typography>
                                                </span>
                                            }
                                        </span>
                                    }
                                </Grid>
                                <Grid item xs={12} sm={4} style={{ textAlign: 'center' }}>
                                    <Typography variant="subtitle1">ESTIMATED DELIVERY TIME</Typography>
                                    <Typography variant="body2">
                                        {LocalDeliveryTime(this.props.quotedOrder.plannedDeliveryStart, this.props.quotedOrder.plannedDeliveryEnd)}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={4} style={{ textAlign: 'right' }}>

                                    <Typography variant="subtitle1">TOTAL PRICE</Typography>

                                    {this.props.quotedOrder.smallOrderFee > 0 &&
                                        <div>
                                            <Typography variant="h4">&nbsp;{this.props.quotedOrder.currency}&nbsp;{(this.props.quotedOrder.basePrice).toFixed(2)}</Typography> 
                                            <Typography
                                                aria-describedby={"fee-pop"}
                                                style={{ display: 'inline-block', position: 'relative', textTransform: "uppercase", marginTop: '-8px' }}
                                                color="error"
                                                variant="h4">
                                                <InfoPopover style={{ position: 'relative', top: '5px', cursor: 'pointer' }}>
                                                    <Typography variant="body1">Your order is smaller than minimal order price of <b style={{ color: 'red' }}>{this.props.quotedOrder.currency}&nbsp;{this.props.quotedOrder.minimalOrderPrice}</b>. You can edit your order sheet and quote again!</Typography>
                                                </InfoPopover>
                                                Small order fee:&nbsp;+{this.props.quotedOrder.currency}&nbsp;{this.props.quotedOrder.smallOrderFee}</Typography>
                                            <hr style={{ marginTop: '2px', marginBottom: '2px' }} />
                                        </div>
                                    }

                                    <Typography variant="h3">&nbsp;{this.props.quotedOrder.currency}&nbsp;{(this.props.quotedOrder.finalPrice).toFixed(2)}</Typography>

                                    {(this.props.quotedOrder.askingPrice - this.props.quotedOrder.basePrice) > 0 &&
                                        <Typography variant="h4" style={{ fontStyle: "italic" }} >with QMO you saves&nbsp;<span style={{ color: 'green' }}>{this.props.quotedOrder.currency}&nbsp;{(Math.round((this.props.quotedOrder.askingPrice - this.props.quotedOrder.basePrice) * 100) / 100).toFixed(2)}</span> !</Typography>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={6} style={{ textAlign: 'left', paddingBottom: '20px' }}>
                            <Button disabled={this.props.orderSheet.items.length === 0} variant="outlined" color="primary" onClick={() => this.props.history.push('/Search')} style={{ maxWidth: '300px', width: '100%' }}>Edit order sheet</Button>
                        </Grid>
                        <Grid item xs={12} sm={6} style={{ textAlign: 'right' }}>
                            <Button 
                                disabled={this.props.orderSheet.items.length === 0} 
                                variant="contained" color="primary" 
                                onClick={() => {
                                    if(this.props.missingProducts && this.props.missingProducts.length > 0 )
                                        this.setState({missingProductsCautionOpen: true})
                                    else
                                        this.props.goNext()
                                }} 
                                style={{ maxWidth: '300px', width: '100%', }}>
                                    Pay and order</Button>
                        </Grid>
                    </Grid >
                )
            }
    }

    render() {
        return (
            <div>

                {!this.props.isBusy && this.props.noneFulfillsOrder !== null ?
                    <div>
                        {this.renderOutcome()}
                    </div>

                    :

                    <QmoLoader qmoAnimation={true} />
                }

                <SimpleMessageQmoModal open={this.state.redirectToOrdersheetsOpen} title="Select order sheet at first" message={() => <span>You have no order sheet selected to be quoted. Use button below to go back and select one.</span>} customButtonsContent={() => {
                    return (<Grid container>
                        <Grid item xs={12} sm={12} style={{ textAlign: 'center' }}>
                            <Button color="primary" variant="contained" onClick={() => {
                                this.props.history.push('/')
                            }}>Select order sheet</Button>
                        </Grid>
                    </Grid>)
                }}></SimpleMessageQmoModal>

                <SimpleMessageQmoModal open={this.state.missingProductsCautionOpen} title="Some products are missing" message={() => <span>This supplier offer doesn't contain all of your ordered products.<br/> Do you want to proceed with available products only?</span>} customButtonsContent={() => {
                    return (<Grid container>
                        <Grid item xs={12} sm={12} style={{ textAlign: 'right' }}>
                            <Button color="primary" variant="outlined" onClick={() => {
                                this.setState({missingProductsCautionOpen: false})
                            }}>Cancel</Button>
                            
                            <Button color="primary" variant="contained" style={{marginLeft:"10px"}} onClick={() => {
                                this.props.goNext()
                            }}>Yes, Proceed</Button>
                        </Grid>
                    </Grid>)
                }}></SimpleMessageQmoModal>

            </div >
        )
    }
}

export default withRouter(Quote);